"use client";

import { useState } from "react";

export default function ContactUsForm() {
  const [statusMessage, setStatusMessage] = useState(null);
  const [statusType, setStatusType] = useState(null); // 'success' or 'error'
  const [isLoading, setIsLoading] = useState(false);
  async function handleSubmit(e) {
    e.preventDefault();

    setIsLoading(true);
    const form = e.target;
    const formData = new FormData(form);

    const data = {
      firstName: formData.get("first-name"),
      lastName: formData.get("last-name"),
      email: formData.get("email"),
      phone: formData.get("phone"),
      company: formData.get("company"),
      message: formData.get("message"),
      hiddenField: formData.get("company-name"),
    };

    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      const result = await res.json();

      if (res.ok && result.success) {
        setStatusType("success");
        setStatusMessage(result.message || "Message sent successfully!");
        form.reset();
      } else {
        setStatusType("error");
        setStatusMessage(result.message || "Something went wrong.");
      }
      setIsLoading(false);
    } catch (error) {
      setStatusType("error");
      setStatusMessage("There was an error sending your message.");
      setIsLoading(false);
    }
  }
  return (
    <div className="flex justify-center items-center w-full bg-white">
      <div className="pt-16 pb-24 sm:pt-24 sm:pb-32 w-full px-6 lg:px-12 max-w-5xl mx-auto">
        <div className="px-6 lg:px-8">
          <div className="w-full">
            <h2 className="text-4xl font-semibold tracking-tight text-pretty text-blue-500 sm:text-5xl">
              Let's work together
            </h2>
            <p className="mt-2 text-lg/8 text-gray-600">
              If you have an application you'd like to talk to us about
              automating, need general service support, or if you would like to
              schedule a demonstration or test a robot application with your
              process, please fill out the form below and we'll get back to you
              right away.
            </p>

            <form onSubmit={handleSubmit} className="mt-16">
              <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                <div>
                  <label
                    htmlFor="first-name"
                    className="block text-sm/6 font-semibold text-gray-900"
                  >
                    First name
                  </label>
                  <div className="mt-2.5">
                    <input
                      id="first-name"
                      name="first-name"
                      type="text"
                      autoComplete="given-name"
                      className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 border placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500"
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="last-name"
                    className="block text-sm/6 font-semibold text-gray-900"
                  >
                    Last name
                  </label>
                  <div className="mt-2.5">
                    <input
                      id="last-name"
                      name="last-name"
                      type="text"
                      autoComplete="family-name"
                      className="block w-full rounded-md border bg-white px-3.5 py-2 text-base text-gray-900   placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500"
                    />
                  </div>
                </div>
                <div className="sm:col-span-2">
                  <label
                    htmlFor="email"
                    className="block text-sm/6 font-semibold text-gray-900"
                  >
                    Email
                  </label>
                  <div className="mt-2.5">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 border placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500"
                    />
                  </div>
                </div>
                <div className="sm:col-span-2">
                  <label
                    htmlFor="company"
                    className="block text-sm/6 font-semibold text-gray-900"
                  >
                    Company
                  </label>
                  <div className="mt-2.5">
                    <input
                      id="company"
                      name="company"
                      type="text"
                      autoComplete="organization"
                      className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 border placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500"
                    />
                  </div>
                </div>
                <div className="sm:col-span-2">
                  <div className="flex justify-between text-sm/6">
                    <label
                      htmlFor="phone"
                      className="block font-semibold text-gray-900"
                    >
                      Phone
                    </label>
                    <p id="phone-description" className="text-gray-400">
                      Optional
                    </p>
                  </div>
                  <div className="mt-2.5">
                    <input
                      id="phone"
                      name="phone"
                      type="tel"
                      autoComplete="tel"
                      aria-describedby="phone-description"
                      className="block w-full rounded-md bg-white  px-3.5 py-2 text-base text-gray-900 border placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500"
                    />
                  </div>
                  <input
                    type="text"
                    name="company-name"
                    style={{ display: "none" }}
                  />
                </div>
                <div className="sm:col-span-2">
                  <div className="flex justify-between text-sm/6">
                    <label
                      htmlFor="message"
                      className="block text-sm/6 font-semibold text-gray-900"
                    >
                      How can we help you? (Required)
                    </label>
                    <p id="message-description" className="text-gray-400">
                      Max 500 characters
                    </p>
                  </div>
                  <div className="mt-2.5">
                    <textarea
                      id="message"
                      name="message"
                      rows={4}
                      aria-describedby="message-description"
                      className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 border placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-500"
                      defaultValue={""}
                    />
                  </div>

                  {/* <div className="flex justify-between mt-5 text-sm/6">
                    <p id="message-description" className="text-gray-400">
                      Max 500 characters
                    </p>
                  </div> */}
                  {statusMessage && (
                    <div
                      className={`rounded-md p-4 my-6 ${
                        statusType === "success"
                          ? "bg-green-100 text-green-800"
                          : "bg-red-100 text-red-800"
                      }`}
                    >
                      {statusMessage}
                    </div>
                  )}
                </div>
              </div>

              <div className="mt-10 flex justify-end border-t border-gray-900/10 pt-8">
                <button
                  type="submit"
                  className={`${isLoading ? "disabled" : ""} rounded-md bg-blue-500 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-xs hover:bg-blue-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition duration-300`}
                >
                  {!isLoading ? "Send message" : "Sending...."}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

// 50Corporate#Encore
